<template>
  <v-container fluid>
    <v-layout text-xs-center wrap>
      <v-flex>
        <data-table-lang
          :students="filteredStudents"
          :loading="loading"
          :exportToCsv="exportToCsv"
        />
      </v-flex>
      <snackbar :id="snackbar.id" :type="snackbar.type" :message="snackbar.message" />
    </v-layout>
  </v-container>
</template>

<script>
import DataTableLang from '@/components/DataTableLang';
import Snackbar from '@/components/Snackbar';
import axios from 'axios';
import uuid from 'uuid';

export default {
  components: {
    DataTableLang,
    Snackbar
  },
  data: () => ({
    students: undefined,
    filteredStudents: undefined,
    loading: false,
    reminderModalOpen: false,
    groupReminderModalOpen: false,
    sending: false,
    modalStudent: undefined,
    snackbar: {
      type: '',
      message: '',
      id: '',
    },
  }),
  async mounted() {
    this.loading = true;
    try {
      const { data: students } = await axios({
        method: 'GET',
        url: `${process.env.VUE_APP_API_URI}/lang-students`,
      });
      this.students = students;
      this.filteredStudents = students;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.snackbar = {
        id: uuid(),
        type: 'error',
        message: 'Erreur de chargement',
      };
    }
  },
  methods: {
    exportToCsv: async function () {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${process.env.VUE_APP_API_URI}/lang-students?format=xlsx`,
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'lang-students.xlsx');
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.snackbar = {
          id: uuid(),
          type: 'error',
          message: 'Erreur de chargement',
        };
      }
    }
  },
};
</script>
